export const MARKETPLACE_DETAILS_SUCCESS = 'MARKETPLACE_DETAILS_SUCCESS';
export const MARKETPLACE_DETAILS_FAILS = 'MARKETPLACE_DETAILS_FAILS';
export const SALES_CHANNEL_FILTER_DATA = 'SALES_CHANNEL_FILTER_DATA';

export function getMarketPlaceDetails({ data }) {
  return {
    type: MARKETPLACE_DETAILS_SUCCESS,
    data,
  };
}

export function getMarketPlaceDetailsError(error) {
  return {
    type: MARKETPLACE_DETAILS_FAILS,
    error,
  };
}

export function setSalesChannelFILTERS(data){
  return {
    type: SALES_CHANNEL_FILTER_DATA,
    data,
  };
}
